export const GET_VERSIONS = 'GET_VERSIONS';
export const GET_EDIT_SONG_VERSIONS = 'GET_EDIT_SONG_VERSIONS';
export const REMOVE_SONG_VERSIONS = 'REMOVE_SONG_VERSIONS';